import { useMutation } from '@apollo/client';

import DeleteModal from '@atom/components/common/DeleteModal';
import textConstants from '@atom/constants/textConstants';
import { USER_UPDATE } from '@atom/graph/user';
import { Progress } from '@atom/mui';
import { UserDetail, UserUpdateInput } from '@atom/types/user';

import classes from './teamControls.module.css';

interface Props {
  open: boolean;
  onClose: () => void;
  userId: string;
  refetch: () => Promise<any>;
}

const DeactivateUserModal = ({ open, onClose, userId, refetch }: Props) => {
  const [updateUser, { loading: updateLoading }] = useMutation<
    { userUpdate: UserDetail },
    { input: UserUpdateInput }
  >(USER_UPDATE, {
    onCompleted: () => {
      refetch();
    },
  });

  const confirm = () => {
    updateUser({
      variables: {
        input: {
          id: userId,
          isActive: false,
        },
      },
    });

    onClose();
  };

  return (
    <DeleteModal
      title="Deactivate User?"
      onConfirm={confirm}
      confirmText="Deactivate"
      onCancel={onClose}
      open={open}
      content={
        updateLoading ? (
          <Progress />
        ) : (
          <div className={classes.modalContent}>
            {textConstants.DEACTIVATE_USER_MODAL_COPY}
          </div>
        )
      }
    />
  );
};

export default DeactivateUserModal;
